import { getData } from "../components/helpers.js";

class TranslateService {
    dictionary = {};

    async getDictionary(category, aliases, object_id = null) {
        // Формируем объект данных для запроса, исключая `object_id`, если оно `null`
        const requestData = {
            lang: window.lang,
            category,
            alias: aliases,
            ...(object_id !== null && { object_id }) // Добавляем `object_id`, только если оно не `null`
        };

        const result = await getData(config.office_url + '/translate', requestData);

        if (result && result.status === 'success') {
            return result.data;
        } else {
            return false;
        }
    }


    async getDictionaryCached(category, aliases, object_id = null) {
        // Фильтруем алиасы, которые уже есть в dictionary
        const missingAliases = aliases.filter(alias => !this.dictionary[`${category}.${alias}`]);

        // Если все алиасы есть в dictionary, возвращаем их из кеша
        if (missingAliases.length === 0) {
            return aliases.reduce((acc, alias) => {
                acc[alias] = this.dictionary[`${category}.${alias}`];
                return acc;
            }, {});
        }

        // Запрашиваем только отсутствующие алиасы
        const result = await this.getDictionary(category, missingAliases, object_id);

        // Если запрос успешен, добавляем новые данные в кеш
        if (result) {
            missingAliases.forEach(alias => {
                this.dictionary[`${category}.${alias}`] = result[alias];
            });
        }

        // Формируем и возвращаем результат с данными из кеша и новыми данными
        return aliases.reduce((acc, alias) => {
            acc[alias] = this.dictionary[`${category}.${alias}`];
            return acc;
        }, {});
    }

    async translate(text) {
        if (this.dictionary[text]) {
            return this.dictionary[text];
        }

        let category, alias;
        if (text.includes('.')) {
            const parts = text.split('.');
            category = parts[0];
            alias = parts[1];
        } else {
            category = 'default';
            alias = text;
        }

        const result = await getData(config.office_url + '/translate', {
            lang: window.lang,
            category,
            alias
        });

        if (result && result.status === 'success' && result.data['alias']) {
            this.dictionary[text] = result.data['alias'];
            return this.dictionary[text];
        } else {
            return false;
        }
    }
}

export default new TranslateService();
